module.exports = __webpack_public_path__ + "static/media/stars-5.dd36893d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PublicWebsite/SocialProof/stars-5.svg
// module id = 525
// module chunks = 0